
define(
	'C3.ShoppingExtensions.ReceiveUpdates'
,   [
		'C3.ShoppingExtensions.ReceiveUpdates.View',
		'C3.ShoppingExtensions.ReceiveUpdates.OptOut.View'
	]
,   function (
		ReceiveUpdatesView,
		ReceiveUpdatesOptOutView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			const layout = container.getComponent('Layout');
			const pageType = container.getComponent('PageType');
			
			if(layout)
			{
				layout.addToViewEventsDefinition(
					'ProductDetails.Full.View',
					'click [data-action="receive-updates"]',
					function (e) 
					{
						e.stopPropagation();
						e.preventDefault();

						var pdp = container.getComponent("PDP");
						var iteminfo = pdp.getItemInfo();
						var item = iteminfo.item;

						var itemImageDetail = item.itemimages_detail
						,   itemImageDetailUrls = ''
						,   itemImgUrl = ''

						if(itemImageDetail && itemImageDetail.urls)
						{
							itemImageDetailUrls = itemImageDetail.urls[0]
							itemImgUrl = itemImageDetailUrls.url
						}
						//console.log(itemImgUrl)
						var view = new ReceiveUpdatesView({
							application: layout.application,
							itemid: item.itemid,
							internalid : item.internalid,
							itemname : item.displayname,
							itemInvQty : item.custitem_qty_available_inv,
							itemKitQty : item.custitem_qty_available_kit,
							itemType : item.itemtype,
							itemKitItemOnly : item.custitem_kit_item_only,
							itemProductGroup : item.custitemproduct_category,
							itemImgUrl : itemImgUrl
						});

						if (view)
						layout.showContent(view, {showInModal: true});
					
				});
			}

			if(pageType){

				const routes = [
	               'receive-updates-opt-out',
	               'receive-updates-opt-out?:options'
	            ];

				pageType.registerPageType({
			        name: 'receive-updates-opt-out',
		            routes: routes,
		            view: ReceiveUpdatesOptOutView,
		            options : {
		            	application : layout.application,
		            	layout : layout
		            }
			    });
			}

		}
	};
});
